import { appContent } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="bg-background-100 rounded-2xl p-8 md:p-12 border border-background-200/70 flex flex-col lg:flex-row items-center gap-8">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">移动端访问</h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed max-w-md">
              {appContent.description}
            </p>
            <div className="mt-6 flex items-center justify-center lg:justify-start gap-4">
              {appContent.platforms.map((platform) => (
                <div
                  key={platform}
                  className="px-4 py-2 bg-background-50 rounded-full border border-background-200/70 text-sm font-medium text-foreground-700 whitespace-nowrap"
                >
                  {platform}
                </div>
              ))}
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="w-48 h-48 md:w-56 md:h-56 rounded-2xl bg-accent-100 flex items-center justify-center overflow-hidden">
              <i className="ri-smartphone-line text-6xl md:text-7xl text-accent-500"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}